import { ArrowLeft, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, Eyebrow } from "../components/Reveal";
import { MEDIA_LOGOS } from "../lib/mediaLogos";
import { MEDIA_HEADLINE, MEDIA_DATE } from "../lib/content";

export default function Media() {
    return (
        <div className="relative overflow-hidden" data-testid="media-page">
            <div className="glow-orb left-[20%] top-[-5%] h-[360px] w-[520px] bg-blue-600/15" />
            <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
                <Reveal className="text-center">
                    <Eyebrow>Press Coverage</Eyebrow>
                    <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl" data-testid="media-page-heading">
                        All Media <span className="cyan-gradient-text">Coverage</span>
                    </h1>
                    <p className="mx-auto mt-4 max-w-2xl text-sm text-slate-400 sm:text-base">
                        "{MEDIA_HEADLINE}" — {MEDIA_DATE}. {MEDIA_LOGOS.length} publications across India covered our
                        initiative. Click any logo to read the original article.
                    </p>
                </Reveal>

                <div className="mt-14 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4" data-testid="media-all-grid">
                    {MEDIA_LOGOS.map((l, i) => (
                        <Reveal key={l.name} delay={(i % 4) * 0.05}>
                            <a
                                href={l.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={`media-all-card-${i}`}
                                className="glow-card group flex h-full flex-col items-center rounded-2xl p-5 transition-transform hover:scale-[1.03]"
                            >
                                <span className="flex h-20 w-full items-center justify-center">
                                    <img
                                        src={l.img}
                                        alt={`${l.name} logo`}
                                        loading="lazy"
                                        className={`max-h-20 w-auto max-w-full object-contain ${
                                            l.bright
                                                ? "[filter:drop-shadow(0_0_12px_rgba(255,255,255,0.45))]"
                                                : "[filter:drop-shadow(0_6px_16px_rgba(0,0,0,0.5))]"
                                        }`}
                                    />
                                </span>
                                <span className="mt-3 flex items-center gap-1.5 text-center text-[11px] font-bold uppercase tracking-wide text-slate-300 group-hover:text-cyan-300">
                                    {l.name} <ExternalLink className="h-3 w-3 opacity-0 transition-opacity group-hover:opacity-100" />
                                </span>
                            </a>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.1}>
                    <div className="mt-12 text-center">
                        <Link
                            to="/"
                            data-testid="media-back-home"
                            className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-7 py-3 text-sm font-semibold text-slate-200 transition-colors hover:border-cyan-500/50 hover:text-cyan-300"
                        >
                            <ArrowLeft className="h-4 w-4" /> Back to Home
                        </Link>
                    </div>
                </Reveal>
            </section>
        </div>
    );
}
